export default "__VITE_ASSET__d7d72d25__"